import { render } from "./B2bMiniCart.vue?vue&type=template&id=0047b043"
import script from "./B2bMiniCart.vue?vue&type=script&lang=js"
export * from "./B2bMiniCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__